export { default as FolderOpenSolidIcon } from './FolderOpenSolidIcon';
